import React from 'react';

type ArrowProps = {
  direction?: 'right' | 'left';
  fill?: string;
  className?: string;
};

const Arrow: React.FC<ArrowProps> = ({
  direction = 'right',
  fill = '#1C0000',
  className,
}) => {
  if (direction === 'left') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        className={className}
        aria-hidden="true"
      >
        <path
          d="M0.292969 5.29609C-0.0976562 5.68672 -0.0976562 6.32109 0.292969 6.71172L5.29297 11.7117C5.68359 12.1023 6.31797 12.1023 6.70859 11.7117C7.09922 11.3211 7.09922 10.6867 6.70859 10.2961L3.41484 7.00234H14.9992C15.5523 7.00234 15.9992 6.55547 15.9992 6.00234C15.9992 5.44922 15.5523 5.00234 14.9992 5.00234H3.41484L6.70859 1.70859C7.09922 1.31797 7.09922 0.683594 6.70859 0.292969C6.31797 -0.0976562 5.68359 -0.0976562 5.29297 0.292969L0.292969 5.29297V5.29609Z"
          fill={fill}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M19.7062 12.7063C20.0969 12.3156 20.0969 11.6813 19.7062 11.2906L14.7063 6.29065C14.3156 5.90002 13.6812 5.90002 13.2906 6.29065C12.9 6.68127 12.9 7.31565 13.2906 7.70627L16.5844 11H5C4.44687 11 4 11.4469 4 12C4 12.5531 4.44687 13 5 13H16.5844L13.2906 16.2938C12.9 16.6844 12.9 17.3188 13.2906 17.7094C13.6812 18.1 14.3156 18.1 14.7063 17.7094L19.7062 12.7094V12.7063Z"
        fill={fill}
      />
    </svg>
  );
};

export default Arrow;
